// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__2WtlN","inputBox":"Form_inputBox__1iKap","btnBox":"Form_btnBox__2TDfN"};